(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4692,4194,2385],{

/***/ 90846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ GrNext; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function GrNext(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "fill": "none",
        "stroke": "#000",
        "strokeWidth": "2",
        "points": "7 2 17 12 7 22"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 80703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ GrPrevious; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function GrPrevious(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "fill": "none",
        "stroke": "#000",
        "strokeWidth": "2",
        "points": "7 2 17 12 7 22",
        "transform": "matrix(-1 0 0 1 24 0)"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 82385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91164);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88116);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98352);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var components_atoms_Icon_gr_GrNext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90846);
/* harmony import */ var components_atoms_Icon_gr_GrPrevious__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80703);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31741);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31857);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);


var _excluded = ["thetitle", "navResponsiveClass", "paginationResponsiveClass", "children", "description"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var swiper = {
  preloadImages: false,
  lazy: true,
  loop: false,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
    pauseOnMouseEnter: true
  },
  pagination: {
    el: ".bbc-slide-pagination",
    clickable: true,
    bulletClass: "bbc-pagination-bullet"
  },
  navigation: {
    nextEl: ".bbc-button-next",
    prevEl: ".bbc-button-prev"
  },
  slidesPerView: 3,
  spaceBetween: 30,
  // Responsive breakpoints
  breakpoints: {
    1280: {
      slidesPerView: 3,
      spaceBetween: 30,
      slidesPerGroup: 3
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 30,
      slidesPerGroup: 2
    },
    768: {
      slidesPerView: 1,
      spaceBetween: 40,
      slidesPerGroup: 1
    },
    320: {
      slidesPerView: 1,
      spaceBetween: 40,
      slidesPerGroup: 1,
      navigation: true
    }
  }
};
/** ========== */

var PostSlider = function PostSlider(_ref) {
  var thetitle = _ref.thetitle,
      navResponsiveClass = _ref.navResponsiveClass,
      paginationResponsiveClass = _ref.paginationResponsiveClass,
      children = _ref.children,
      description = _ref.description,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
    className: "relative",
    children: [thetitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      className: "title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800",
      children: thetitle
    }), description && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
      className: "mb-6 text-center lg:mb-10",
      children: description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, _objectSpread(_objectSpread(_objectSpread({
      modules: [swiper__WEBPACK_IMPORTED_MODULE_1__/* .Autoplay */ .pt, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Navigation */ .W_, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Pagination */ .tl],
      className: " !p-4"
    }, swiper), props), {}, {
      children: [children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: "bbc-slide-pagination relative  block pt-6 text-center ".concat(props.showPaginationClass || " lg:invisible", " ").concat(paginationResponsiveClass)
      })]
    })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
      className: "absolute top-1/2 left-1/2 hidden w-full -translate-x-1/2 -translate-y-1/2 lg:flex ".concat(navResponsiveClass),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: "bbc-button-prev ".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btn), "  ").concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btnPrev), " "),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_Icon_gr_GrPrevious__WEBPACK_IMPORTED_MODULE_7__/* .GrPrevious */ .U, {
          size: 18,
          className: "text-red-400"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: "bbc-button-next ".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btn), "  ").concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btnNext), " "),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_Icon_gr_GrNext__WEBPACK_IMPORTED_MODULE_6__/* .GrNext */ .U, {
          size: 18,
          className: "text-red-400"
        })
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (PostSlider);
PostSlider.defaultProps = {
  thetitle: null
};
/** ========== */

/***/ }),

/***/ 59208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ guide_and_tool; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/Wave/index.js
var Wave = __webpack_require__(67370);
// EXTERNAL MODULE: ./components/templates/offshore/guide-and-tool/components-tool/BusinessGuides/index.js
var BusinessGuides = __webpack_require__(4970);
// EXTERNAL MODULE: ./components/templates/offshore/guide-and-tool/components-tool/ToolTabList/index.js
var ToolTabList = __webpack_require__(6809);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91164);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(98352);
// EXTERNAL MODULE: ./components/atoms/LinkRouter/index.js
var LinkRouter = __webpack_require__(27597);
// EXTERNAL MODULE: ./components/organisms/PostSlider/index.js
var PostSlider = __webpack_require__(82385);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/hk/guide-and-tool/components-tool/ServiceCategory/index.js


var _excluded = ["data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var ServiceCard = function ServiceCard(_ref) {
  var data = _ref.data,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: props.className,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
      className: "block h-full",
      href: data === null || data === void 0 ? void 0 : data.link,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "shadow-[0px_0px _20px_rgba(124,120,120,0.2)] flex h-full w-full flex-col justify-between rounded bg-bbc-gradient-service p-6 lg:rounded-xl",
        style: {
          minHeight: "260px"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, _objectSpread({
          className: "mx-auto",
          wrapper: {
            className: "w-full relative"
          }
        }, data === null || data === void 0 ? void 0 : data.image)), /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          text: data === null || data === void 0 ? void 0 : data.title,
          as: "h3",
          className: "text-lg font-semibold text-bbc-brand-700 ".concat(data !== null && data !== void 0 && data.description ? "mb-6" : "")
        }), (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-black",
          children: data.description
        })]
      })
    })
  });
};

var SerivceSlider = function SerivceSlider(_ref2) {
  var listContent = _ref2.listContent;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PostSlider["default"], {
    children: Array.isArray(listContent) && listContent.length > 0 && listContent.map(function (item, itemIdx) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
        className: "col-4 h-auto",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceCard, {
          data: item
        })
      }, itemIdx);
    })
  });
};

var Component = function Component(_ref3) {
  var title = _ref3.title,
      subTitle = _ref3.subTitle,
      description = _ref3.description,
      dataList = _ref3.dataList;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "container relative z-10 text-center",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
      text: title,
      className: "title-h2 mb-6 px-7 text-bbc-30px text-bbc-brand-700"
    }), subTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
      text: subTitle,
      className: "title-h2 mb-2 text-bbc-30px text-bbc-brand-700 lg:mb-10 lg:text-4xl lg:leading-[50px]"
    }), description && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "mb-10 lg:mb-8",
      children: description
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hidden lg:block",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col-10 mx-auto",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "row gap-y-10",
          children: dataList && dataList.length > 0 && dataList.map(function (item, itemIdx) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceCard, {
              data: item,
              className: "lg:col-4"
            }, itemIdx);
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "lg:hidden",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SerivceSlider, {
        listContent: dataList
      })
    })]
  });
};

/* harmony default export */ var ServiceCategory = (Component);
;// CONCATENATED MODULE: ./components/templates/hk/guide-and-tool/index.js


function guide_and_tool_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function guide_and_tool_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { guide_and_tool_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { guide_and_tool_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var GuideAndTool = function GuideAndTool(_ref) {
  var _dataJson$dataToolAnd, _dataJson$dataToolAnd2, _dataJson$dataToolAnd3, _dataJson$dataToolAnd4;

  var dataJson = _ref.dataJson;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "relative ",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
      minHeightBanner: "banner-min-h-569",
      breadcrumbs: dataJson === null || dataJson === void 0 ? void 0 : dataJson.breadcrumbs,
      title: dataJson === null || dataJson === void 0 ? void 0 : dataJson.title,
      titleProps: {
        className: "banner-default-title mb-4 lg:mb-10",
        textColor: "banner-title-default-color"
      },
      description: dataJson === null || dataJson === void 0 ? void 0 : dataJson.description,
      descriptionProps: {
        className: "text-center lg:text-left lg:pr-20"
      },
      leftClassName: "lg:col-7",
      rightClassName: "lg:col-5",
      rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: dataJson === null || dataJson === void 0 ? void 0 : dataJson.banner_image,
        className: "h-full w-full",
        wrapper: {
          className: "bbc-banner-image-country pb-10 lg:pb-0"
        },
        width: (dataJson === null || dataJson === void 0 ? void 0 : dataJson.banner_image_width) || 516,
        height: (dataJson === null || dataJson === void 0 ? void 0 : dataJson.banner_image_height) || 420,
        alt: "banner-img"
      }),
      bgColor: "bg-bbc-gradient-8"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      id: "section-business-guide",
      className: "mt-10 lg:mt-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(BusinessGuides/* default */.Z, {
        title: "Business guides",
        description: dataJson === null || dataJson === void 0 ? void 0 : dataJson.businessDescription,
        dataList: dataJson === null || dataJson === void 0 ? void 0 : dataJson.dataBusinessGuides,
        wrapperStyles: "lg:col-12",
        contentStyles: "lg:col-4"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Wave/* Wave */.i, {
      background: "lg:bg-[#EFF6FF]",
      srcTop: "/assets/images/wave/top_bg-wave.png",
      imgWidthTop: 1920,
      imgHeightTop: 125,
      srcBottom: "/assets/images/wave/bottom-wave.png",
      imgWidthBottom: 1920,
      imgHeightBottom: 140,
      style: {
        top: "40%"
      },
      heightBottom: " h-4/5 ",
      sectionTop: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container relative z-10 text-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          text: (_dataJson$dataToolAnd = dataJson.dataToolAndResources) === null || _dataJson$dataToolAnd === void 0 ? void 0 : _dataJson$dataToolAnd.title,
          className: "title-h2 mb-2 text-bbc-30px text-bbc-brand-700 lg:mb-10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-8 lg:mb-10",
          children: (_dataJson$dataToolAnd2 = dataJson.dataToolAndResources) === null || _dataJson$dataToolAnd2 === void 0 ? void 0 : _dataJson$dataToolAnd2.description
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "row justify-center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 px-0 lg:col-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "h-full",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, guide_and_tool_objectSpread({
                wrapper: {
                  className: "w-full h-auto flex justify-center lg:justify-start items-center bottom-0 top-20 pb-10"
                },
                className: "w-full",
                alt: "resources-img"
              }, (_dataJson$dataToolAnd3 = dataJson.dataToolAndResources) === null || _dataJson$dataToolAnd3 === void 0 ? void 0 : _dataJson$dataToolAnd3.image))
            })
          })
        })]
      }),
      sectionBottom: /*#__PURE__*/(0,jsx_runtime.jsx)(ToolTabList/* default */.Z, {
        dataList: (_dataJson$dataToolAnd4 = dataJson.dataToolAndResources) === null || _dataJson$dataToolAnd4 === void 0 ? void 0 : _dataJson$dataToolAnd4.data
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      id: "section-service-category",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceCategory, {
        title: "We have more for you to try below",
        description: "Recommended Reading",
        dataList: dataJson.services
      })
    })]
  });
};

/* harmony default export */ var guide_and_tool = (GuideAndTool);

/***/ }),

/***/ 45307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./components/templates/hk/guide-and-tool/index.js + 1 modules
var guide_and_tool = __webpack_require__(59208);
;// CONCATENATED MODULE: ./pages/hk/guide-and-tool/data.json
var data_namespaceObject = JSON.parse('{"country":"Hong Kong","banner_image":"/assets/images/hk/guide-and-tool/banner-hk-tools.png","banner_image_width":651,"banner_image_height":432,"title":"Starting Your Business With Ease","description":"Here you\'ll find useful tips, free checklists, and online tools to help you start and run your company.","businessDescription":"Core business insights in Hong Kong at your fingertip. Select and download away!","breadcrumbs":[{"title":"Home","uri":"/"},{"title":"Guide & Tool"}],"dataBusinessGuides":[{"title":"Hong Kong E book","description":"Walk the right path towards company startup in Hong Kong with this ebook.","pageUrl":"hong-kong-ebook","image":{"src":"/assets/images/hk/guide-and-tool/ebook-hk-tools.png","alt":"hongkong-ebook","width":220,"height":316},"url":"/hk/guide-and-tool/hong-kong-ebook-download","post_modal":{"form_id":20,"country":"Hong Kong"}},{"title":"Hong Kong Incorporation Checklist","description":"Keep yourself focused on the essentials when starting a business in Hong Kong.","pageUrl":"hong-kong-incorporation-checklist","image":{"src":"/assets/images/hk/guide-and-tool/checklist-hk-tools.png","alt":"hongkong-checklist","width":243,"height":315},"url":"/hk/guide-and-tool/hong-kong-incorporation-checklist","ebook_modal":{"imgLeftSrc":"/assets/images/hk/common/checklist-hk-common.png","triggerName":"Incorporation Checklist - Hong Kong","apiLink":"api/portal/contact_form/ebook","contactFromId":34}},{"title":"Hong Kong E-commerce Guide","description":"Turn your E-commerce dream into reality with our exclusive guide.","pageUrl":"hong-kong-ecommerce-guide","image":{"src":"/assets/images/hk/guide-and-tool/ecommerce_guide-hk-tools.png","alt":"hongkong-e-commerce-guide","width":220,"height":316},"url":"/hk/guide-and-tool/hong-kong-ecommerce-guide"},{"title":"Hong Kong Offshore Company<br/>For Overseas Trade","description":"Start an overseas trade operation with a Hong Kong offshore company","pageUrl":"hong-kong-trading-guide","image":{"src":"/assets/images/hk/guide-and-tool/trading-hk-tools.png","alt":"hongkong-trading","width":660,"height":945},"url":"/hk/guide-and-tool/hong-kong-trading-guide"}],"dataToolAndResources":{"title":"Tools and resources","description":"Help yourself to our library of tools & resources that cover business-essential aspects such as company setup and compliance management.","image":{"src":"/assets/images/hk/guide-and-tool/resources-hk-tools.png","width":920,"height":518},"data":[{"name":"Plan your business","isActive":true,"tools":[{"name":"Business Name Generator","image":{"src":"/assets/images/common/tools/name_generator-tools.png","alt":"name-check","width":447,"height":261},"description":"Try this tool to help you come up with new short, catchy name ideas for your long-awaited company.","url":"/guide-and-tool/name-generator"},{"name":"Hong Kong Company Name Check","image":{"src":"/assets/images/common/tools/name_check-tools.png","alt":"name-check","width":446,"height":261},"description":"Your business name matters. Use our handy Entity Name Check to see if it\'s up for taking.","url":"/guide-and-tool/hong-kong-company-name-check"},{"name":"Hong Kong Offshore Claim Tool","image":{"src":"/assets/images/hk/guide-and-tool/claiming-hk-tools.png","alt":"offshore-claiming","width":447,"height":261},"description":"Knowing tax liability comes first when running a business in Hong Kong. Try our tool now!","url":"/guide-and-tool/hong-kong-offshore-claim-tool"},{"name":"Hong Kong Cost Planning Tool","image":{"src":"/assets/images/hk/guide-and-tool/cost_plaining-hk-tools.png","alt":"cost-plaining","width":446,"height":261},"description":"Create the right startup budget for your new Hong Kong company.","url":"/guide-and-tool/hong-kong-cost-planning-tool"}]},{"name":"Manage your business","isActive":false,"tools":[{"name":"Hong Kong Compliance Guide","image":{"src":"/assets/images/common/tools/compliance_calendar-tools.png","alt":"compliance-calendar","width":447,"height":261},"description":"Get an overview of your reporting obligations and important timelines here.","url":"/guide-and-tool/hong-kong-compliance-guide"},{"name":"Accounting Service Fee Calculator","image":{"src":"/assets/images/hk/guide-and-tool/tools/accounting-service.png","alt":"accounting-service","width":447,"height":262},"description":"Get an estimation of yearly accounting costs based on your monthly transaction.","url":"/accounting-and-auditing#accounting-auditing"}]}]},"services":[{"image":{"src":"/assets/images/common/tools/incorporation-tools.png","alt":"incorporation","width":166,"height":150},"title":"Incorporation","description":"","link":"/articles/incorporation"},{"image":{"src":"/assets/images/common/tools/banking_system-tools.png","alt":"banking-system","width":162,"height":150},"title":"Banking System","description":"","link":"/articles/banking-system"},{"image":{"src":"/assets/images/common/tools/tax_comliance-tools.png","alt":"tax-and-compliance","width":156,"height":149},"title":"Tax & Compliance","description":"","link":"/articles/tax-and-compliance"},{"image":{"src":"/assets/images/common/tools/workpass_others-tools.png","alt":"workpass-and-others","width":176,"height":150},"title":"Workpass & Others","description":"","link":"/articles/workpass-and-others"},{"image":{"src":"/assets/images/common/tools/e_commerce-tools.png","alt":"e-commerce","width":186,"height":150},"title":"E-Commerce","description":"","link":"/articles/e-commerce"},{"image":{"src":"/assets/images/common/tools/trading-tools.png","alt":"trading","width":190,"height":150},"title":"Trading","description":"","link":"/articles/trading"}]}');
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/hk/guide-and-tool/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    locationRouter: "hk",
    page: data === null || data === void 0 ? void 0 : data.page,
    background: "bg-bbc-brand-100 lg:bg-bbc-main",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(guide_and_tool/* default */.Z, {
      dataJson: data_namespaceObject
    })
  });
}

/***/ }),

/***/ 36785:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hk/guide-and-tool",
      function () {
        return __webpack_require__(45307);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31857:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btn":"Index_btn___obRs","btnPrev":"Index_btnPrev__kxfmc","btnNext":"Index_btnNext__V4iBC"};

/***/ }),

/***/ 92:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 68770:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 30933:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9885,8352,7795,4090,9738,7447,8990,2888,179], function() { return __webpack_exec__(36785); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);